<template>
  <section> 
    <b-row style="width:500px;margin: auto;">
      <b-col>
        <b-card
          v-if="!logged"
          style="max-width: 100%;" >
          <template v-slot:header >
            <div class="header-card text-left">
              Ingresar al sistema  
              <div style="float:right;background: url('images/logo.svg');width:89px;height:37px;background-size: cover;">
                  
              </div>
            </div>      
            <small>Bienvenido(a) y que tengas un gran día. <b-icon font-scale="1.6" style="vertical-align:bottom" icon="brightness-high"></b-icon></small>      
          </template> 
          <validation-observer v-slot="{ invalid } ">
          <b-form autocomplete="off">     
             <div class="p-3">     
              <b-form-group
                  class="mb-0"
                  label="Email"
                  label-for="input-email"
                  description=""
                >
                <validation-provider immediate 
                  rules="required|email" 
                  v-slot="{ errors }" 
                  style="position:relative"> 
                  <b-form-input
                    id="input-email"
                    v-model="users.email"
                    placeholder=""
                  ></b-form-input>
                    <small  class="text-danger input-errors-table" style="padding-top:3px">{{errors[0]}}</small>
                </validation-provider> 
              </b-form-group> 
              <b-form-group
                  class="mb-0"
                  label="Contraseña"
                  label-for="input-password"
                  description=""
                >
                <validation-provider immediate 
                  rules="required" 
                  v-slot="{ errors }" 
                  style="position:relative"> 
                  <b-form-input
                    type="password"
                    id="input-password"
                    v-model="users.password"
                    placeholder=""
                  ></b-form-input>
                    <small  class="text-danger input-errors-table">{{errors[0]}}</small>
                </validation-provider> 
              </b-form-group>
              <div> 
                <b-button type="button"  style="padding:0" variant="white" class="btn-link">Recordar contraseña</b-button>
                <b-button type="button" :disabled="invalid" @click="login(users);" variant="info" style="float:right">Ingresar</b-button>
              </div>       
            </div>     
          </b-form>    
          </validation-observer>      
        </b-card>
      </b-col>
    </b-row>
    <div class="panel-notification" style="bottom: 80px;top: inherit;" v-if="errornotification" > 
      <div style="position:relative">
          <button type="button" @click="errorNot()" class="close close-notification" aria-label="Close">
              <span aria-hidden="true">&times;</span>
          </button>
          <b-icon style="position: absolute;left: -32px;top: 3px;" icon="exclamation-triangle" scale="1.5" variant="danger"></b-icon>          
          <h6>Datos invalidos</h6>
      </div>
  </div>                   
  </section>  
</template>

<script>
import indexMix  from './indexMix.js'
import SwInputs from '@/components/forms/inputs.vue'
import { ValidationProvider } from 'vee-validate'
import { ValidationObserver } from 'vee-validate'


export default { 
  name: "datos_pacientes",
  mixins: [indexMix],
  components: {
  SwInputs,     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
.close:focus{
  outline: none !important;
}
</style>

